import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Chip,
} from "@mui/material";
import styles from "./styles.module.scss";
import moment from "moment";
import { Blog } from "types/blogs";
import { ReactComponent as OtlLogo } from "../../../otl-logo.svg";

type Props = {
  blog: Blog;
};

export const BlogCard = ({ blog }: Props) => {
  const publishedAt = moment(blog?.publishedAt).format("MMMM DD, YYYY");

  return (
    <Card className="card" elevation={0}>
      <CardActionArea sx={{ padding: { xs: "0.5rem", lg: "1rem" } }}>
        <CardMedia
          id="card-media"
          component="img"
          image={blog.image}
          alt={blog.title}
          sx={{ borderRadius: "4px", height: { xs: "120px", md: "240px" } }}
        />
        <CardContent
          sx={{
            padding: "unset",
            paddingTop: { xs: "0.5rem", lg: "1rem" },
            paddingBottom: { xs: "0.25rem", lg: "0.5rem" },
          }}
        >
          {blog.tags &&
            blog.tags.map((tag) => {
              return (
                <Chip
                  key={tag}
                  sx={{
                    marginBottom: { xs: "0.5rem", lg: "1rem" },
                    borderRadius: "6px",
                    marginInlineEnd: "6px",
                  }}
                  label={tag}
                  color="primary"
                  size="small"
                />
              );
            })}

          <Typography variant="h5" className={styles.card__title}>
            {blog.title}
          </Typography>

          <Box className={styles.card__footer}>
            <Box className={styles.card__avatar__name}>
              <OtlLogo className={styles.otl__logo} />
              <Typography
                variant="body1"
                id="author"
                className={styles.card__footer__author}
              >
                {blog.source}
              </Typography>
            </Box>
            <Typography
              variant="body1"
              id="published-at"
              className={styles.card__footer__publish__date}
            >
              {publishedAt}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
